module.exports = __webpack_public_path__ + "1.4.15-unryo/img/offline-unknown-4.5e7f8026.svg";